













































































































import { Component, Vue } from 'vue-property-decorator';
import { db } from '@/main';
import * as firebase from 'firebase/app';
import User from '@/interfaces/User';
import Store from '@/interfaces/Store';
import Settings from '@/interfaces/Settings';
import uniqid from 'uniqid';
import {
  required, email, confirmed, min,
} from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} is required.',
});

extend('email', {
  ...email,
  message: '{_field_} must be valid.',
});

extend('confirmed', {
  ...confirmed,
  message: '{_field_} does not match.',
});

extend('min', {
  ...min,
  message: '{_field_} may not be less than {length} characters.',
});

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AccountCreation extends Vue {
  active: number;

  userObject: User;

  storeObject: Store;

  confirmPassword: string;

  // hasInviteCode: string;

  constructor() {
    super();
    this.active = 1;
    this.userObject = {
      name: '',
      email: '',
      password: '',
      phoneNumber: '',
      createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
      modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
      emailVerified: false,
    };
    this.storeObject = {
      storeName: '',
      storeAddress: '',
      createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
      modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    this.confirmPassword = '';
  }

  continueStep(step: number) {
    (this.$refs.basicObserver as Vue & { validate: () => Promise<boolean> })
      .validate().then((success) => {
        if (!success) return;

        this.active = step;
      });
  }

  registerAccount() {
    (this.$refs.basicObserver as Vue & { validate: () => Promise<boolean> })
      .validate().then((success) => {
        if (!success) return;

        firebase.auth().createUserWithEmailAndPassword(this.userObject.email, this.userObject.password ?? '')
          .then((data) => {
            this.storeObject.createdAt = firebase.firestore.Timestamp.fromDate(new Date());
            this.storeObject.modifiedAt = firebase.firestore.Timestamp.fromDate(new Date());
            this.storeObject.inviteCode = uniqid();
            db.collection('stores').add(this.storeObject).then((res) => {
              delete this.userObject.password;
              this.userObject.id = data?.user?.uid;
              this.userObject.createdAt = firebase.firestore.Timestamp.fromDate(new Date());
              this.userObject.modifiedAt = firebase.firestore.Timestamp.fromDate(new Date());
              this.userObject.storeId = res.id;
              this.userObject.emailVerified = data?.user?.emailVerified ?? false;
              db.collection('users').doc(this.userObject.id).set(this.userObject).then(() => {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const updateProfile = data?.user?.updateProfile({
                  displayName: this.userObject.name,
                });
                const newStoreSettings = this.initDefaultSettings(res.id, data?.user?.uid);
                db.collection('settings').add(newStoreSettings);
              });
            });
          });
      });
  }

  initDefaultSettings(storeId: string, userId?: string): Settings {
    return {
      storeHours: [],
      isAlwaysOpen: false,
      restockWarningThreshold: 30,
      restockDangerThreshold: 10,
      name: '',
      modifiedAt: firebase.firestore.Timestamp.fromDate(new Date()),
      createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
      modifiedBy: userId ?? '',
      enabled: true,
      storeId,
      description: '',
    };
  }
}
